function toDefaultPrecision(value: number): number {
  return Number(value.toFixed(2));
}

export function parseFloatWithDefaultPrecision(value: string): number {
  return toDefaultPrecision(parseFloat(value));
}

export default toDefaultPrecision;
